var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-8 w-8 stroke-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }